import { useEffect, useState } from "react";
import RenderLevel from "./components/RenderLevel";
import { useRecoilState } from "recoil";
import { spriteSheetImageAtom } from "./atoms/spriteSheetImageAtom";
import {
  LOCAL_STORAGE_SCENE_MODE,
  SCENE_GAME,
  SCENE_HOW_TO_PLAY,
  SCENE_BEGINNING_STORY,
  SCENE_TITLE,
  SPRITE_SHEET_SRC,
  SCENE_ENDING_STORY,
} from "./helpers/consts";
import sounds, { SFX } from "./classes/Sounds";
import TitleScreen from "./components/title/TitleScreen";
import TitleHowToPlay from "./components/title/TitleHowToPlay";
import StoryFramesSequence from "./components/title/StoryFramesSequence";
import { beginningFrames, endingFrames } from "./story/storyPrompts";

// Boot up global SFX module
sounds.init();

const initialScene =
  window.localStorage.getItem(LOCAL_STORAGE_SCENE_MODE) ?? SCENE_TITLE;

function App() {
  const [spriteSheetImage, setSpriteSheetImage] =
    useRecoilState(spriteSheetImageAtom);
  const [scene, setScene] = useState(initialScene);

  useEffect(() => {
    // Load our sprite sheet image, set it in Atom state for other components to access
    const image = new Image();
    image.src = SPRITE_SHEET_SRC;
    image.onload = () => {
      setSpriteSheetImage(image);
    };
  }, [setSpriteSheetImage]);

  const changeScene = (newValue) => {
    window.localStorage.setItem(LOCAL_STORAGE_SCENE_MODE, newValue);
    sounds.playSfx(SFX.CLICK);
    setScene(newValue);
  };

  //Do not render anything until image is ready
  if (!spriteSheetImage) {
    return null;
  }
  if (scene === SCENE_TITLE) {
    return (
      <TitleScreen
        onEnter={() => {
          changeScene(SCENE_BEGINNING_STORY);
        }}
      />
    );
  }
  if (scene === SCENE_BEGINNING_STORY) {
    return (
      <StoryFramesSequence
        storyFrames={beginningFrames}
        onEnter={() => {
          changeScene(SCENE_HOW_TO_PLAY);
        }}
      />
    );
  }
  if (scene === SCENE_ENDING_STORY) {
    return (
      <StoryFramesSequence
        storyFrames={endingFrames}
        onEnter={() => {
          changeScene(SCENE_TITLE);
        }}
      />
    );
  }

  if (scene === SCENE_HOW_TO_PLAY) {
    return (
      <TitleHowToPlay
        onEnter={() => {
          changeScene(SCENE_GAME);
        }}
      />
    );
  }

  return (
    <RenderLevel
      onBackToTitle={() => {
        changeScene(SCENE_TITLE);
      }}
      onGoToEndingScene={() => {
        changeScene(SCENE_ENDING_STORY);
      }}
    />
  );
}

export default App;
